import React, { useState } from 'react';
import NotificationsActiveOutlined from "@material-ui/icons/NotificationsActiveOutlined";
// import SystemIcon from '../../components/ShortStatus/SystemIcon';
import Card from '../../../components/Card/CardTS';
import CardBody from '../../../components/Card/CardBody';
import CardHeader from '../../../components/Card/CardHeaderTS';
import CardIcon from '../../../components/Card/CardIcon';
import GridItem from '../../../components/Grid/GridItem';
import GridContainer from '../../../components/Grid/GridContainer';
import ErrorComponent from '../../components/ErrorComponent/ErrorComponent';
import { unregisterFromMobileApp } from '../../stores/actions/accountActions';
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
const headerTextColor = '#3C4858';
interface UnregisterFromMobileAppProps {
    accountID: number;
    unregisterFromMobileAppConfirmed: boolean;
    unregisterFromMobileApp: (accountID: number) => void;
}

const UnregisterFromMobileApp = ({
    accountID,
    unregisterFromMobileAppConfirmed,
    unregisterFromMobileApp
}: UnregisterFromMobileAppProps) => {
    const [disableUnregisterButton, setDisableUnregisterButton] = useState(false);
	const handleUnregister = (): void => {
		setDisableUnregisterButton(true);
		unregisterFromMobileApp(accountID);
	};

    return (
        <ErrorComponent message='Unregister crashed' Children>
            <GridItem xs={12}>
                <Card className='UnregisterFromMobileApp'>
                    <CardHeader color='info' icon>
                        <CardIcon color='info'>
                            <NotificationsActiveOutlined />
                        </CardIcon>
                        <h4 style={{ color: headerTextColor }}>
                            Unregister from WISENE Watch
                        </h4>
                    </CardHeader>
                    <CardBody style={{ textAlign: 'center' }}>
                        <p>
                            Click to unpair your account from WISENE Watch.
                        </p>
                        <Button
                            disabled={disableUnregisterButton}
                            variant='contained'
                            style={{
                                backgroundColor: '#f55145',
                                color: '#ffffff',
                                transition: '0.2s',
                                marginTop: '60px',
                            }}
                            onClick={handleUnregister}
                        >
                            Unregister
                        </Button>
                    </CardBody>
                </Card>
            </GridItem>
        </ErrorComponent >
    );
};


const mapStateToProps = (state) => ({
	unregisterFromMobileAppConfirmed: state.account.unregisterFromMobileAppConfirmed,
});
const actions = {
	unregisterFromMobileApp,
};

export default connect(mapStateToProps, actions)(UnregisterFromMobileApp);
